import {
    mdiFaceAgent,
    mdiFacebook,
} from '@mdi/js'
import clsx from 'clsx'
import {IconHref} from 'swayok-react-mdb-ui-kit/components/Icon/IconHref'
import {appUrl} from '../../../../AppUrl'
import {useRegionConfig} from '../../../../hooks'

interface VnContactsExternalLinksProps {
    className?: string
}

// Блок с внешними ссылками на способы связи для футера (Вьетнам).
export function VnContactsExternalLinks(props: VnContactsExternalLinksProps) {

    const {
        className = clsx(
            'lh-sm mt-2 d-flex flex-row align-items-center justify-content-center gap-3',
            'justify-content-md-end',
            'mt-lg-1 justify-content-lg-start'
        ),
    } = props

    const regionConfig = useRegionConfig()
    return (
        <li className={className}>
            <IconHref
                path={mdiFaceAgent}
                href={appUrl().support.askQuestion}
            />
            {regionConfig.contacts.facebook && (
                <IconHref
                    path={mdiFacebook}
                    href={regionConfig.contacts.facebook}
                    target="_blank"
                    className="facebook-link"
                />
            )}
            {regionConfig.contacts.zalo && (
                <a
                    href={regionConfig.contacts.zalo}
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src="/img/logos/zalo_logo.svg"
                        alt="Zalo"
                        height="18"
                    />
                </a>
            )}
        </li>
    )
}
